<template>
    <div>
        <div class="sidebar-wrapper">
            <SideNav feather="plus-circle" :action="addProduct" />
        </div>
        <div class="p-3">
            <b-switch style="float:right;padding-right: 0 !important;" class="is-flex is-justify-content-center  p-2 mr-0 " size="" v-model="isTab">
                            <span class="small"></span> 
                            
                        </b-switch>
            <b-tabs position="is-centered" type="is" >
                <b-tab-item color="is-success" icon="account" label="By You">
                        <template #header>
                            <!-- <b-icon icon="account"></b-icon> -->
                            <span> All Products <b-tag rounded> {{ allProducts.length }} </b-tag> </span>
                        </template>
                        
                    <!-- <OrderTemplate v-if="pending.length > 0" :orders="pending" /> -->
                        <div class="pt-2 ">
                            <div class="py-3" style="max-width:460px;">
                                    <b-field label="">
                                        <b-input autocomplete="0" @input="Search" @keyup.native="load" :loading="loading" autofocus v-model="searchString" placeholder="Search products "></b-input>
                                    </b-field>
                            </div>
                            
                            <div class="p-2 ">
                                <ProductTemplate :edit="edit" :products="allProducts" v-if="allProducts.length > 0 && result.length == 0 && !isTab" />
                            </div>
                            
                            <!--  -->
                            <b-tabs v-if="getCategories.length > 0 && isTab && result.length == 0" position="is-centered" type="is" size="is-">
                                <b-tab-item v-for="cat in getCategories" :key="cat" color="is-success" :label="cat">
                                    <template #header>
                                        <!-- <b-icon icon="account"></b-icon> -->
                                        <span> {{ cat }} <b-tag rounded> {{ (allProducts.filter((pro) => pro.category == cat)).length }} </b-tag> </span>
                                    </template>
                                    <!--  -->
                                    <ProductTemplate :edit="edit" :products="allProducts.filter((pro) => pro.category == cat)" :categoryView="false" v-if="(allProducts.filter((pro) => pro.category == cat)).length > 0 && result.length == 0 && isTab" />
                                </b-tab-item>
                            </b-tabs>
                            
                            <ProductTemplate :edit="edit" :products="result" :categoryView="false" v-if="result.length > 0" />
                            <!-- <b-loading v-model="isLoading" :can-cancel="true"></b-loading> -->
                            <!-- <ProductTemplate :products="getUserProducts" v-if="getUserProducts.length > 0 && result.length == 0" /> -->
                            <!-- <ProductSkeleton v-else/> -->
                        </div>

                        
                </b-tab-item>

                <!-- <b-tab-item v-if="true" color="is-success" icon="account-star" label="By Admin">
                    <template #header>
                            <span> By Admin <b-tag rounded> {{ getAdminProducts.length }} </b-tag> </span>
                        </template>
                        
                        <div class="pt-2 ">
                            <div class="py-3" style="max-width:460px;">
                                    <b-field label="">
                                        <b-input autocomplete="0" @input="Search" @keyup.native="load" :loading="loading" autofocus v-model="searchString" placeholder="Search products "></b-input>
                                    </b-field>
                            </div>

                            <b-tabs v-if="getCategories.length > 0" position="is-centered" type="is" size="is-">
                                <b-tab-item v-for="cat in getCategories" :key="cat" color="is-success" :label="cat">
                                    <template #header>
                                        <span> {{ cat }} <b-tag rounded> {{ (getAdminProducts.filter((pro) => pro.category == cat)).length }} </b-tag> </span>
                                    </template>
                                    <ProductTemplate :edit="edit" :products="getAdminProducts.filter((pro) => pro.category == cat)" :categoryView="false" v-if="(getAdminProducts.filter((pro) => pro.category == cat)).length > 0 && result.length == 0" />
                                    </b-tab-item>
                            </b-tabs>
                            <ProductTemplate :edit="edit" :products="result" :categoryView="false" v-if="result.length > 0" />
                        </div>
                </b-tab-item> -->

                <b-tab-item v-if="true" color="is-success" icon="account-star" label="Categories">
                    <template #header>
                            <!-- <b-icon icon="account-star"></b-icon> -->
                            <span> Categories <b-tag rounded> {{ getCategories ? getCategories.length : 0 }} </b-tag></span>
                        </template>

                        <ul class="menu-list" style="max-width:460px;">
                            <li v-for="cat in getCategories" :key="cat">
                                
                                <a class="my-1">
                                    <p class="title is-6 has-text-weight-normal" style="font-weight: "><b-tag style="float:right" rounded> {{ allProducts.filter((pro)=>pro.category == cat).length }} </b-tag> {{ cat }} </p>
                                    <!-- <p class="subtitle is-6">Kpeshie</p> -->
                                </a>
                                <hr class="m-0 p-0">
                            </li>
                            <li>
                                
                                <a class="my-1">
                                    <p class="title is-6" style="font-weight: "><b-tag style="float:right" rounded> {{ allProducts.length }} </b-tag> Total </p>
                                    <!-- <p class="subtitle is-6">Kpeshie</p> -->
                                </a>
                                <hr class="m-0 p-0">
                            </li>
                        </ul>
                </b-tab-item>
                
            </b-tabs>
        </div>

        
        
        <b-modal v-if="isCardModalActive" v-model="isCardModalActive" width="460px"  scroll="keep">
            <div class="p-4 has-bg-whte" >
                <div class="content p-1 mb-1">
                    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="true"></b-loading>
                    <!-- <hr> -->
                    <div class="p-5 card ">
                        <div class="pt-4 mb-4">
                            <h4 v-if="!editProduct" class="title is-4 px-2 mb-1"> Add Product</h4>
                            <h4 v-else class="title is-4 px-2 mb-1"> Edit Product: {{ form.product }} </h4>
                        </div>
                        <b-carousel v-if="dropFiles.length > 0">
                            <b-carousel-item v-for="(image, i) in dropFiles" :key="i">
                                <b-image
                                     :src="window.URL.createObjectURL(image)"
                                    width="100px"
                                    height="100px"
                                    style="object-fit:cover"
                                ></b-image>
                            </b-carousel-item>
                        </b-carousel>
                        <b-carousel v-else-if="form.images.length > 0">
                            <b-carousel-item v-for="(image, i) in form.images" :key="i">
                                <b-image
                                    :src="image" :alt="form.name"
                                    width="100px"
                                    height="100px"
                                    style="object-fit:cover"
                                ></b-image>
                            </b-carousel-item>
                        </b-carousel>
                        <!-- <figure v-if="dropFiles" class="b-image-wrapper image is-16by9 m-1">
                            <img
                                
                                :src="img"
                                ratio="16by9"
                            />
                        </figure> -->
                        
                        <b-field v-if="dropFiles" :type="im.type" :message="im.message">
                            <!-- <b-progress type="is-main" v-if="uploadProgress" :value="uploadProgress" show-value format="percent"></b-progress> -->
                            <span style="font-size:0.85rem" v-if="uploadProgress > 0"> Kindly wait, files being uploaded</span>
                            <b-upload v-if="dropFiles.length == 0" v-model="dropFiles"
                                drag-drop
                                multiple
                                accept="image/png,image/jpeg"
                                expanded>
                                <section class="section p-3">
                                    <div class="content has-text-centered">
                                        <p class="mb-0">
                                            <b-icon
                                                icon="upload"
                                                size="is-">
                                            </b-icon>
                                        </p>
                                        <p>Drag & Drop images / upload</p>
                                    </div>
                                </section>
                            </b-upload>
                        </b-field>
                        <span v-if="dropFiles.length == 0" class="tag is-primary mb-2" >
                            <p class="size-is-7">Image dimensions: 300 x 300</p>
                        </span>
                        <div class="tags">
                            <span v-for="(file, index) in dropFiles" :key="index" class="tag is-primary">
                                {{file.name}}
                                <button class="delete is-small" type="button" @click="deleteDropFile(index)"></button>
                            </span>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <b-field label="" :type="pr.type" :message="pr.message">
                                    <b-input @input="validateProduct()" autofocus v-model="form.product" placeholder="Product name"></b-input>
                                </b-field>
                            </div>
                        </div>
                        <div class="columns is-mobile">
                                <div class="column">
                                    <b-field label="">
                                        <b-input v-model="form.tags" placeholder="Product tags e.g tag1, tag2, tag3" ></b-input>
                                    </b-field>
                                </div>
                         </div>
                        <div class="columns is-mobile">
                                <!-- <div class="column is-2">
                                    
                                </div> -->
                                <div class="column is-half">
                                    <b-field label="" :type="cat.type" :message="cat.message">
                                        <b-button type="is-primary" style="padding:1.5rem 1rem" icon-left="plus" @click="$router.push('/shop')"></b-button>
                                        <b-select @input="validateCategory" expanded v-if="categorySelect" v-model="form.category" placeholder="Category">
                                            <option
                                                v-for="cat in getCategories"
                                                :value="cat"
                                                :key="cat">
                                                {{ cat }}
                                            </option>
                                        </b-select>
                                        <!-- <b-input v-else v-model="form.category" @input="validateCategory" placeholder="category"></b-input> -->
                                    </b-field>
                                </div>
                                <div class="column">
                                    <b-field label="" :type="typ.type" :message="typ.message">
                                        <!-- <b-button type="is-primary" style="padding:1.5rem 1rem" icon-left="switch" @click="switchType"></b-button> -->
                                        <b-select expanded v-if="typeSelect" @change="validateType" v-model="form.type" placeholder="Type">
                                            <option
                                                v-for="type in types"
                                                :value="type"
                                                :key="type">
                                                {{ type }}
                                            </option>
                                        </b-select>
                                        <!-- <b-input v-else v-model="form.type" @input="validateType" placeholder="Type"></b-input> -->
                                    </b-field>
                                </div>
                            </div>
                            
                            <div class="columns is-mobile">
                                <div class="column">
                                    <b-field label="" :type="typ.type" :message="typ.message">
                                        <b-select expanded @change="validateOfferType" v-model="form.offerType" placeholder="Offer Type">
                                            <option
                                                v-for="type in offerTypes"
                                                :value="type"
                                                :key="type">
                                                {{ type }}
                                            </option>
                                        </b-select>
                                    </b-field>
                                </div>
                                <div class="column">
                                    <b-field :type="pc.type" :message="pc.message">
                                        <b-input step="0.01" type="number" @input="validatePrice()" v-model="form.price" placeholder="Price"></b-input>
                                    </b-field>
                                </div>
                            </div>
                        <!-- <div class="p-3">
                            <b-field v-if="!editProduct">
                                <b-switch v-model="form.visible">Visible</b-switch>
                            </b-field>
                        </div> -->
                            <div class="columns is-mobile pt-0">
                                <div class="column is-6 mb-0 pb-0">
                                    <!-- <b-field label="" message="">
                                        <b-numberinput 
                                            placeholder="Discount"
                                            controls-position="compact"
                                            step="5"
                                            v-model="form.discount"
                                            aria-minus-label="Decrement by 5"
                                            aria-plus-label="Increment by 5">
                                        </b-numberinput>
                                    </b-field> -->
                                    <b-field label="" class="px-4">
                                        <b-slider @input="getDiscounted" v-model="form.discount" :custom-formatter="(val) => + val + '%'" :tooltip="false" indicator></b-slider>
                                    </b-field>
                                    
                                    <span class="px-2" v-if="this.form.discount > 0 && this.form.price > 0"> Discount Price: {{computeDiscounted}} </span>
                                </div>
                                <div class="column ">
                                    <b-numberinput @input="getDiscounted" controls-alignment="right" :controls="false" type="number" v-model="form.discount" placeholder="Discount"></b-numberinput>
                                </div>
                                <div class="column">
                                    <b-field>
                                        <b-numberinput step="0.01" controls-alignment="right" :controls="false" type="number" @input="genDiscount" v-model="form.discounted" placeholder="Discounted"></b-numberinput>
                                    </b-field>
                                </div>
                            </div>
                            <div class="columns is-mobile">
                                <div class="column is-half">
                                    <b-switch size="is-small" v-model="form.visible">Visible Product</b-switch>
                                </div>
                                <div class="column is-half">
                                    <b-switch size="is-small" v-model="form.limited">Limited Offer</b-switch>
                                </div>
                            </div>
                            <div class="columns is-mobile">
                                <div class="column is-half">
                                    <b-switch size="is-small" v-model="form.available">In Stock</b-switch>
                                </div>
                                <div class="column is-half">
                                    <b-switch size="is-small" v-model="form.expiry"> Expiry Offer</b-switch>
                                </div>
                            </div>
                            <div class="columns ">
                                <div class="column">
                                    <b-field label="Offer Start Date">
                                        <b-datepicker
                                            :disabled="!form.expiry"
                                            v-model="form.start"
                                            icon="calendar-today"
                                            placeholder="Offer Start Date"
                                            :icon-right="form.start ? 'close-circle' : ''"
                                            icon-right-clickable
                                            @icon-right-click="clearStart"
                                            trap-focus>
                                        </b-datepicker>
                                    </b-field>
                                </div>
                                <div class="column">
                                    <b-field label="Offer End Date">
                                        <b-datepicker
                                            :disabled="!form.expiry"
                                            v-model="form.end"
                                            icon="calendar-today"
                                            placeholder="Offer End Date "
                                            :icon-right="form.end ? 'close-circle' : ''"
                                            icon-right-clickable
                                            @icon-right-click="clearEnd"
                                            trap-focus>
                                        </b-datepicker>
                                    </b-field>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-7 mb-0 pb-0">
                                    <b-field label="" :type="det.type" :message="det.message">
                                        <b-input @input="validateDetails()" v-model="form.details" placeholder="Product details" maxlength=""></b-input>
                                    </b-field>
                                </div>
                                
                            </div> 
                            <div class="columns is-mobile mb-0">
                                <div class="column">
                                    <b-field label="">
                                        <b-input style="height:" type="textarea"
                                            minlength="10"
                                            v-model="form.description"
                                            placeholder="Description">
                                        </b-input>
                                    </b-field>
                                </div>
                            </div>

                            <b-field class="py-0">
                                <b-button expanded @click="onSubmit" rounded class="is-submit-button" type="is-dark">Submit</b-button>
                            </b-field>
                        
                    </div>
                </div>
                <!-- <div class="px-2 py-1"> -->
                    <!-- <b-button  type="is-primary has-text-weight-medium" class="is-submit-button" rounded expanded>Submit</b-button> -->
                    <!-- <b-button  style="position:absolute;bottom: 10px;width: 100%;margin:auto" type="mx-3 is-primary has-text-weight-medium" class="is-submit-button" rounded expanded>Add to Cart</b-button> -->
                <!-- </div> -->
                
            </div>
        </b-modal>
    </div>
</template>

<script>

    import { mapGetters, mapActions} from 'vuex'
    import MainFooter from '../components/footer'
    import SideNav from '../components/sidenav'
    import ProductTemplate from '../components/ProductTemplate'
    import axios from 'axios'

    export default {
        name: "ProductPage",
        data() {
            return {
                window: null,
                editProduct: false,
                isTab: false,
                img: '',
                dropFiles: [],
                result: [],
                searchString: '',
                isLoading: false,
                loading: false,
                isCardModalActive: false,
                categorySelect: true,
                typeSelect: true,
                types: ['Product', 'Service', 'Virtual'],
                offerTypes: ['Promo', 'Discount', 'Multibuy', 'Gift with Purchase', 'Coupon'],
                form: {
                    shop: '',
                    product: '',
                    images: [],
                    category: null,
                    type: 'Product',
                    offerType: null,
                    details: '',
                    visible: true,
                    limited: false,
                    available: true,
                    price: null,
                    start: null,
                    end: null,
                    discount: 0,
                    discounted: 0,
                    description: '',
                    tags: '',
                    expiry: false,
                    by: ''
                },
                im: {
                    type:'',
                    message:'',
                },
                pr: {
                    type:'',
                    message:'',
                },
                pc: {
                    type:'',
                    message:'',
                },
                cat: {
                    type:'',
                    message:'',
                },
                typ: {
                    type:'',
                    message:'',
                },
                det: {
                    type:'',
                    message:'',
                },
                uploadProgress: 0,
                show: true,
                submitted: false
            }
        },
        components: {
            // MainFooter,
            ProductTemplate,
            SideNav
        },
        watch: {
            submitted() {
                if (this.submitted == true) {
                    //

                }
            },
            searchString() {
                if (this.searchString.length == 0) {
                    this.result = []
                }
            },
            isCardModalActive() {
                if (!this.isCardModalActive) {
                    this.editProduct = false
                    
                    this.form.product = ''
                    this.form.images = []
                    this.form.category = ''
                    this.form.type = 'Product'
                    this.form.details = ''
                    this.offerType = null
                    this.form.visible = true
                    this.form.limited = false
                    this.form.available = true
                    this.form.price = ''
                    this.form.start = null
                    this.form.end = null
                    this.form.expiry = false
                    this.form.price = ''
                    this.form.discount = 0
                    this.form.discounted = 0
                    this.form.description = ''
                    // this.form = product
                    this.form.tags = ''
                }
            },
            dropFiles() {
                //
                // this.validateImg()
                //
                if (this.dropFiles.length > 0){
                    // this.img = window.URL.createObjectURL(this.dropFiles)
                    

                    // const ax = this.axios.create({
                    //     baseURL: 'https://api.cloudinary.com/'
                    // })

                    // //
                    // ax.post('/v1_1/df8hf97qf/image/upload', formData,
                    //         { onUploadProgress: ProgressEvent => {
                    //             let progress = Math.round((ProgressEvent.loaded / ProgressEvent.total) * 100)
                    //             this.uploadProgress = progress
                    //           },
                    //         })
                    //         .then( (res) =>  {
                    //           console.log(res)
                    //           //
                    //           this.form.image = res.data.secure_url
                    //          //
                    //          if (res.data.message == 'Success') {
                    //            this.$buefy.toast.open(`Successfully uploaded`)
                    //            // success
                    //            this.uploadProgress = 0;
                    //         //    this.dropFiles = [];

                    //         //    setTimeout(()=> {
                    //         //       this.refresh()
                    //         //     }, 800)
                    //          }
                    //         }).catch((err)=> {
                    //             console.log(err)
                    //           this.uploadProgress = 0
                    //           this.$buefy.toast.open(`Failed: ${err.response.data}`)
                    //         })
                    
                }

                else  {
                    window.URL.revokeObjectURL(this.dropFiles)
                }
            }
        },
        mounted() {
            this.getProducts()
            this.window = window
            //
            this.form.shop = this.getUser.name
            this.form.by = this.getUser.shop
        },
        computed: {
            ...mapGetters('auth', ['getUser']),
            ...mapGetters('products', ['allProducts']),

            getAdminProducts() {
                return this.allProducts.filter( (pro)=> pro.by == 'Admin')
            },
            getUserProducts() {
                return this.allProducts.filter( (pro)=> pro.by !== 'Admin')
            },
            getCategories() {

                // const allcategories =  this.allProducts.map(product => product.category)
                // const categories  = [...new Set(allcategories)].sort()
                const categories  = this.getUser.categories
                return categories
            },
            computeDiscounted(){
                // return Math.round((this.form.price * ((100 - parseFloat(this.form.discount))/100) * 1000), 2)/1000
                return (this.form.price * ((100 - parseFloat(this.form.discount))/100)).toFixed(2)
            },
            getNewProduct(){
                return this.$store.getters['products/newProduct']
            },
            getUpdateProduct(){
                return this.$store.getters['products/updateProduct']
            }

        },
        methods: {
            clearStart () {
                this.form.start = null
            },
            clearEnd () {
                this.form.end = null
            },
            validateImg() {
                if (this.dropFiles.length == 0){
                    this.im.type = 'is-danger';
                    this.im.message ='Kindly select image file(s)'
                    return false
                }

                else {
                    this.im.type = 'is-success';
                    this.im.message =''
                    return true
                }
            },
            validateProduct() {
                if (this.form.product.length < 3){
                    this.pr.type = 'is-danger';
                    this.pr.message ='Enter 3-characters or above'
                    return false
                }

                if (this.form.product.length >= 3){
                    this.pr.type = 'is-success';
                    this.pr.message =''
                    return true
                }
            },
            validatePrice() {

                const reg = new RegExp(/^\d*\.?\d*$/)

                if (this.form.price == null) {
                    this.pc.type = 'is-danger';
                    this.pc.message ='Kindly enter price'
                    return false
                }
                
                else if (reg.test(this.form.price)) {

                    // if (this.form.price.length > 0){
                        this.pc.type = 'is-success';
                        this.pc.message =''
                        return true
                    // }
                    // else {
                    //     this.pc.type = 'is-danger';
                    //     this.pc.message ='Kindly enter a valid price'
                    //     return false
                    // }
                } else {
                    if (this.form.price.length <=8){
                        this.pc.type = 'is-danger';
                        this.pc.message ='Kindly enter a number'
                        return false
                    }
                }

                this.genDiscount()
                this.getDiscounted()

                
            },
            validateCategory() {
                if (this.form.category == null || this.form.category.length < 3){
                    this.cat.type = 'is-danger';
                    this.cat.message ='Select above / Enter 3-characters or above'
                    return false
                }

                if (this.form.category.length >= 3){
                    this.cat.type = 'is-success';
                    this.cat.message =''
                    return true
                }
            },
            validateType() {
                if ( this.form.type == null || this.form.type.length < 3){
                    this.typ.type = 'is-danger';
                    this.typ.message ='Select above / Enter 3-characters or above'
                    return false
                }

                if (this.form.type.length >= 3){
                    this.typ.type = 'is-success';
                    this.typ.message =''
                    return true
                }
            },
            validateOfferType() {
                if ( this.form.offerType == null){
                    this.typ.type = 'is-danger';
                    this.typ.message ='Select offer type'
                    return false
                }

                if (this.form.offerType){
                    this.typ.type = 'is-success';
                    this.typ.message =''
                    return true
                }
            },
            validateDetails() {
                if (this.form.details.length < 3){
                    this.det.type = 'is-danger';
                    this.det.message =' Enter 3-characters or above'
                    return false
                }

                if (this.form.details.length >= 3){
                    this.det.type = 'is-success';
                    this.det.message =''
                    return true
                }
            },
            deleteDropFile(index) {
                this.dropFiles.splice(index, 1)
            },
            addProduct(){
                this.isCardModalActive = true
            },
            edit(product) {
                this.form.shop = product.shop
                this.form.product = product.product
                this.form.images = product.images
                this.form.category = product.category
                this.form.type = product.type
                this.form.details = product.details
                this.form.offerType = product.offerType
                this.form.visible = product.visible
                this.form.limited = product.limited
                this.form.available = product.available
                this.form.price = product.price
                this.form.start = product.start ? new Date(product.start) : null
                this.form.end = product.end ? new Date(product.end) : null
                this.form.expiry = product.expiry
                this.form.price = product.price
                this.form.discount = product.discount
                this.form.description = product.description
                this.form.by = product.by
                // delete this.form.visible
                // this.form = product
                this.form.tags = (product.tags.length > 0) ? product.tags.join(',') : ''
                this.editProduct = product.product
                this.isCardModalActive =true
            },
            onSubmit() {

                // validate
                if ( !this.validateProduct() || !this.validateCategory() || !this.validateType() || !this.validateDetails() || !this.validatePrice()){
                    return
                }

                this.isLoading = true

                if (this.editProduct){

                    axios.patch('/product/'+this.editProduct, this.form).then((res)=>{

                        //
                        this.$buefy.toast.open(res.data)
                        //
                        this.isCardModalActive = false

                        this.getProducts()

                        this.isLoading = false
                        // clear
                        // this.$store.dispatch('products/clearNewUpdate', 'update')
                    }).catch(error=>{
                        this.$buefy.toast.open('Oops, Failed to update product')
                    })

                }  else {


                    axios.post('/product/', this.form).then((res)=>{

                        this.$buefy.toast.open(res.data)
                        //
                        this.isCardModalActive = false
                        // clear
                        // this.$store.dispatch('products/clearNewUpdate', 'new')
                        
                        this.getProducts()

                        this.isLoading = false
                        
                    }).catch(error=>{
                        this.$buefy.toast.open('Oops, Failed to Add product')

                    })
                }

                //

                if (this.dropFiles && this.dropFiles.length > 0) {
            
                    //
                    const cloudURL = 'https://api.cloudinary.com/v1_1/df8hf97qf/image/upload'
                    //
                    const links = [];
                    const product = JSON.parse(JSON.stringify(this.form))
                    //
                    for (let i = 0; i < this.dropFiles.length; i++) {

                        const img = this.dropFiles[i];

                        const formData = new FormData()
                        formData.append('upload_preset', 'qwwhqvhe')
                        formData.append('folder', 'shopnscan/products/')
                        // set
                        formData.append('file', img)
                        //
                        fetch(cloudURL, {
                            method: 'POST',
                            body: formData
                        }).then(async response=> {
                                    
                            const data = await response.json()

                            if (!response.ok) {
                                const error = (data && data.message) || response.status

                                this.$swal({
                                    title:"Failed!",
                                    text: data.message,
                                    type:'error'
                                });

                                return Promise.reject(error)
                            }

                            links.push(data.secure_url);

                            // this.product.image = data.secure_url

                            if (i == (this.dropFiles.length - 1) ) {
                            
                            if (data && links.length > 0) {
                                
                                setTimeout(()=>{

                                    axios.patch('/product/image/'+encodeURIComponent(product.product), { images: links, shop: this.getUser.name }).then(() =>{
                                        //
                                        // this.$swal({
                                        //   title:"Good job!",
                                        //   text: response.data,
                                        //   type:'success'
                                        // });
                                        //
                                        this.getProducts()

                                    }).catch( e => {
                                        this.$swal({
                                            title:"Failed!",
                                            text: e.response.data,
                                            type:'error'
                                        });
                                    })

                                }, 600)
                                
                            }
                            }

                        })
                    }
                    
                }
                // upload to cloudinary first
                // if (this.dropFiles.length > 0){

                    
                    //
                    // const formData = new FormData()
                    // formData.append('upload_preset', 'qwwhqvhe')
                    // formData.append('folder', 'products/')
                    // // formData.append('public_id', this.dropFiles.name)
                    // formData.append('file', this.dropFiles)

                    // fetch(cloudURL, {
                    //     method: 'POST',
                    //     body: formData
                    // }).then(async response=> {
                    //     const data = await response.json()

                    //     if (!response.ok) {
                    //         const error = (data && data.message) || response.status
                    //         return Promise.reject(error)
                    //     }

                    //     //
                    //     this.form.images = data.secure_url
                    //     this.form.tags = this.form.tags.includes(',') ? this.form.tags.split(',') : ''
                    //     this.form.shop = this.getUser.shop
                    //     this.form.by = this.getUser.shop
                    //     //
                    //     this.form.price = parseFloat(this.form.price)
                            
                        
                    // })

                    
                // } else {

                    

                    
                    
                // }

                //

            },
            switchCategory() {
                this.categorySelect = this.categorySelect ? false : true
            },
            switchType() {
                this.typeSelect = this.typeSelect ? false : true
            },
            async getProducts() {
                await this.$store.dispatch('products/getProducts', this.getUser.name)
                
            },
            async Search() {
                // console.log('here')
                if (this.searchString.length >= 3) {
                    
                   
                    const result = await this.$store.getters['products/searchProducts'](this.searchString)

                    this.result = result
                    
                }
            },
            load() {
                this.loading = true 
                setTimeout(()=>{
                    this.loading = false
                }, 500)
            },
            genDiscount () {
                const dd = ((this.form.price - this.form.discounted) / this.form.price) * 100;

                this.form.discount = (Math.round(dd * 1000))/1000
            },
            getDiscounted(){
                // return Math.round((this.form.price * ((100 - parseFloat(this.form.discount))/100) * 1000), 2)/1000
                this.form.discounted = (Math.round(this.form.price * ((100 - parseFloat(this.form.discount))/100)) * 1000)/1000;
            },
        }
    }
</script>

<style lang="scss" >
@import '@/assets/scss/custom_variables.scss';

    .tabs li.is-active a {
        border-bottom-color: $primary !important;
        color: $primary !important;
    }

    .minus > button, .plus > button{
        padding: 1.5rem 1rem;
    }

    .textarea:not([rows]) { 

        min-height: 5em !important;
    }
</style>